export default __webpack_public_path__ + "static/media/pencil.48a509a8.png";